"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.function.name");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

var _objectSpread2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/objectSpread2"));

require("core-js/modules/es6.regexp.search");

var _moment = _interopRequireDefault(require("moment"));

var _Pagination = _interopRequireDefault(require("@/components/Pagination"));

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

var _PermissionPage = _interopRequireDefault(require("@/components/Page/PermissionPage"));

var _PermissionSimplePage = _interopRequireDefault(require("@/components/Page/PermissionSimplePage"));

var _CustomTableColumn = _interopRequireDefault(require("@/mixins/CustomTableColumn"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// secondary package based on el-pagination
// Custom Table Column Mixins (Omega Theme)
var _default = {
  name: "codeSort:view",
  mixins: [_CustomTableColumn.default],
  permission: "dictionaryCategory",
  extends: _PermissionPage.default,
  components: {
    Pagination: _Pagination.default,
    PermissionSimplePage: _PermissionSimplePage.default
  },
  data: function data() {
    return {
      viewOnly: false,
      paginationOptions: {
        page: 1,
        limit: 10
      },
      showDialog: false,
      allDepartments: [],
      allRoles: [],
      roles: [],
      tableData: [],
      totalData: 0,
      search: "",
      formData: {},
      formTitle: "",
      formButton: "",
      rules: {
        name: [{
          required: true,
          message: this.$t("system.codeSort.categoryName") + this.$t("SMS.canNotBeEmpty"),
          trigger: "blur"
        }],
        code: [{
          required: true,
          message: this.$t("system.codeSort.categoryCode") + this.$t("SMS.canNotBeEmpty"),
          trigger: "blur"
        }]
      },
      toBeDelete: null,
      loading: true
    };
  },
  created: function created() {
    this.fetchData();
  },
  methods: {
    fetchData: function fetchData() {
      var _this2 = this;

      var _this = this;

      _this.loading = true;

      _httpUtils.default.post("codeSort", "list", null, {
        pageNum: _this.paginationOptions.page,
        pageSize: _this.paginationOptions.limit,
        name: _this.search
      }).then(function (res) {
        if (res.code == 200) {
          _this.tableData = res.data.rows;
          _this.totalData = res.data.total;
        } else {
          _this.$notify({
            title: _this2.$t("common.error"),
            message: _this2.$t("common.fetchError"),
            type: "error"
          });
        }

        _this.loading = false;
      }).catch(function (err) {
        _this.$notify({
          title: _this2.$t("common.error"),
          message: _this2.$t("common.fetchError") + ',' + err.message,
          type: "error"
        });

        _this.loading = false;
      });
    },
    addData: function addData(data) {
      var _this3 = this;

      var _this = this;

      _httpUtils.default.post("codeSort", "add", null, data).then(function (res) {
        if (res.code == 200) {
          _this.fetchData();

          _this.closeDialog();

          _this.$notify({
            title: _this.$t("common.success"),
            message: _this.$t("system.codeSortAdd.addFormSuccessText"),
            type: "success"
          });
        } else {
          _this.$notify({
            title: _this.$t("common.error"),
            message: res.message,
            type: "error"
          });
        }
      }).catch(function (err) {
        _this.$notify({
          title: _this3.$t("common.error"),
          message: _this3.$t("common.fetchError") + ',' + err.message,
          type: "error"
        });
      });
    },
    updateData: function updateData(data) {
      var _this4 = this;

      var _this = this;

      _httpUtils.default.post("codeSort", "update", null, data).then(function (res) {
        if (res.code == 200) {
          _this.fetchData();

          _this.closeDialog();

          _this.$notify({
            title: _this.$t("common.success"),
            message: _this.$t("system.codeSortUpdate.updateFormSuccessText"),
            type: "success"
          });
        } else {
          _this.$notify({
            title: _this.$t("common.error"),
            message: res.message,
            type: "error"
          });
        }
      }).catch(function (err) {
        _this.$notify({
          title: _this4.$t("common.error"),
          message: _this4.$t("common.fetchError") + ',' + err.message,
          type: "error"
        });
      });
    },
    deleteData: function deleteData(data) {
      var _this5 = this;

      var _this = this;

      _httpUtils.default.post("codeSort", "delete", null, data).then(function (res) {
        if (res.code == 200) {
          _this.fetchData();

          _this.$notify({
            title: _this.$t("common.success"),
            message: _this.$t("system.codeSort.deleteCodeSortsSuccessText"),
            type: "success"
          });
        } else {
          _this.$notify({
            title: _this.$t("common.error"),
            message: res.message,
            type: "error"
          });
        }
      }).catch(function (err) {
        _this.$notify({
          title: _this5.$t("common.error"),
          message: _this5.$t("common.fetchError") + ',' + err.message,
          type: "error"
        });
      });
    },
    handleSearch: function handleSearch() {
      this.paginationOptions.page = 1;
      this.paginationOptions.limit = 10;
      this.fetchData();
    },
    handleDialog: function handleDialog(cmd, id) {
      var _this6 = this;

      this.initForm(cmd);

      if (cmd == "view") {
        this.viewOnly = true;
        this.fillForm(id);
      }

      if (cmd == "edit") this.fillForm(id);
      this.$nextTick(function () {
        return _this6.showDialog = true;
      });
    },
    handlePagination: function handlePagination(newOptions) {
      var _this7 = this;

      this.paginationOptions = newOptions;
      this.$nextTick(function () {
        return _this7.fetchData();
      });
    },
    handleRecover: function handleRecover() {
      this.$notify({
        title: "Success",
        message: "Recover Successful",
        type: "success"
      });
    },
    handleSubmit: function handleSubmit() {
      var _this8 = this;

      this.$refs["dataForm"].validate(function (valid) {
        if (valid) {
          var dummy = (0, _objectSpread2.default)({}, _this8.formData);

          _this8.$nextTick(function () {
            if (dummy.id) {
              _this8.updateData(dummy);
            } else {
              _this8.addData(dummy);
            }
          });
        }
      });
    },
    handleDelete: function handleDelete(codeSortIds) {
      var _this9 = this;

      this.$confirm(this.$t("system.codeSort.toolBarDeleteConfirmInformation"), this.$t("common.warning"), {
        confirmButtonText: this.$t("common.delete"),
        cancelButtonText: this.$t("common.cancel"),
        type: "warning"
      }).then(function () {
        return _this9.deleteData([codeSortIds]);
      }).catch(function () {
        return null;
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.toBeDelete = val;
    },
    handleMultipleDelete: function handleMultipleDelete() {
      var _this10 = this;

      var temp = this.toBeDelete;

      if (!temp) {
        this.$notify({
          title: this.$t("common.error"),
          message: this.$t("system.codeSort.toolBarDeleteWarnText"),
          type: "error"
        });
        return;
      }

      var codeSortIds = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = temp[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var data = _step.value;
          codeSortIds.push(data.id);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.$confirm(this.$t("system.codeSort.toolBarDeleteConfirmInformation"), this.$t("common.warning"), {
        confirmButtonText: this.$t("common.delete"),
        cancelButtonText: this.$t("common.cancel"),
        type: "warning"
      }).then(function () {
        return _this10.deleteData(codeSortIds);
      }).catch(function () {
        return null;
      });
    },
    initForm: function initForm(cmd) {
      if (cmd == "add") {
        this.formTitle = this.$t("system.codeSort.tableAddOpenText");
        this.formButton = this.$t("common.add");
      } else if (cmd == "edit") {
        this.formTitle = this.$t("system.codeSort.toolEditOpenText");
        this.formButton = this.$t("common.edit");
      }

      this.viewOnly = false;
    },
    fillForm: function fillForm(id) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.tableData[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var data = _step2.value;

          if (data.id == id) {
            var deptId = [];
            this.formData = {
              id: data.id,
              name: data.name,
              code: data.code,
              parentCode: data.parentCode,
              descreption: data.descreption,
              remark: data.remark
            };
            return;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    closeDialog: function closeDialog() {
      var _this11 = this;

      this.showDialog = false;
      this.formData = {};
      this.$nextTick(function () {
        return _this11.$refs["dataForm"].clearValidate();
      });
    },
    dateFormat: function dateFormat(date) {
      if (date == undefined) {
        return "";
      }

      return (0, _moment.default)(date).format("YYYY-MM-DD HH:mm:ss");
    }
  }
};
exports.default = _default;